import { render, staticRenderFns } from "./soilChart.vue?vue&type=template&id=02d90a16&scoped=true"
import script from "./soilChart.vue?vue&type=script&lang=js"
export * from "./soilChart.vue?vue&type=script&lang=js"
import style0 from "./soilChart.vue?vue&type=style&index=0&id=02d90a16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d90a16",
  null
  
)

export default component.exports